import { render, staticRenderFns } from "./PersonDetail.vue?vue&type=template&id=4a447e9e&"
import script from "./PersonDetail.vue?vue&type=script&lang=ts&"
export * from "./PersonDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports